// extracted by mini-css-extract-plugin
export default {"dialog":"CustomerAddressDialog_dialog__zHxEQ"};